import { matchPath } from "react-router";

import {
  type EventTabParam,
  EventTagEnum,
  routeByEventTagEnum,
} from "~/types/tag";

const DASHBOARD_TAB_PARAMS: EventTabParam[] = [
  EventTagEnum.NEW,
  EventTagEnum.ENDING_SOON,
];

export const getDashboardTabFromPathname = (
  pathname: string
): EventTabParam | undefined =>
  DASHBOARD_TAB_PARAMS.find((tab) =>
    matchPath({ path: routeByEventTagEnum[tab], end: true }, pathname)
  );
